import React from 'react';
import 'chart.js/auto';
import { Pie } from 'react-chartjs-2';
import { Paper, Typography } from '@mui/material';

const PieChartMoviment = ({ data, title }) => {
  const chartData = {
    labels: data.map((item) => item.nomMoviment),
    datasets: [
      {
        data: data.map((item) => item.importAgregat.saldo),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4CAF50', '#666666',
          '#FF5722', '#AAAAAA', ],
      },
    ],
  };

  return (
    <Paper sx={{ padding: '20px' }}>
      <Typography variant="h6">{title}</Typography>
      <Pie data={chartData} />
    </Paper>
  );
};

export default PieChartMoviment;
